/**
 * Reducer index file
 *
 * @package    src/containers
 * @author     YingTuring <ying@turing.com>
 * @copyright  2018 Turing Company
 * @license    Turing License
 * @version    2.0
 * @link       https://turing.ly
 */
import dashboard from './Dashboard'
import drawerReducer from './Drawer'
import authReducer from './Auth'
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

/* dv2_temporary_solution */
import problemEditorReducer from '../dv2_temporary_solution/reducers/problemEditorReducer';
import challengeEditorReducer from '../dv2_temporary_solution/reducers/challengeEditorReducer';
import jobEditorReducer from '../dv2_temporary_solution/reducers/jobEditorReducer';
import jobListReducer from '../dv2_temporary_solution/reducers/jobListReducer';
import challengeScoreReducer from '../dv2_temporary_solution/reducers/challengeScoreReducer';
import userObjectReducer from '../dv2_temporary_solution/reducers/saveUserTokenObjReducer';
import mcqChallengeReducer from '../dv2_temporary_solution/reducers/mcqChallengeReducer';
import { reducers as NewUIReducers } from '../dv2_temporary_solution/UI_V2_Components/reducers';
import { eventReducer } from '../dv2_temporary_solution/components/admin/CalendarScheduledEvent/EventReducer';
import { accRecordingReducer } from '../dv2_temporary_solution/reducers/accRecordingReducer';
import SoftSkillsReducer from '../v3/legacy_components/UI_V2_Components/SoftSkills/SoftSkills.reducer'
import { reducers as NewOnboardingUiUxReducers } from '../v3/legacy_components/UI_V2_Components/Onboarding/OnboardingNewUiUx/reducers';
import HomeV2Reducer from '../v3/legacy_components/UI_V2_Components/home/HomeV2/homeV2.reducer';
import settingsV2Reducer from '../v3/containers/Dashboard/SettingsV2/SettingsV2.reducer';
/* End dv2_temporary_solution */

/**
 * Combine reducers
 */
const appReducers = combineReducers({
  dashboard,
  drawer: drawerReducer,
  auth: authReducer,
  form: formReducer,
  /* dv2_temporary_solution */
  problemEditor: problemEditorReducer,
  challengeEditor: challengeEditorReducer,
  jobEditor: jobEditorReducer,
  jobList: jobListReducer,
  challengeScore: challengeScoreReducer,
  userObject: userObjectReducer,
  mcqChallengeObject: mcqChallengeReducer,
  ...NewUIReducers,
  events: eventReducer,
  acc_recording: accRecordingReducer,
  softSkills: SoftSkillsReducer,
  /* End dv2_temporary_solution */
  ...NewOnboardingUiUxReducers,
  homeV2: HomeV2Reducer,
  settingsV2: settingsV2Reducer,
})

export const RESET_ALL_STORE_DATA = "RESET_ALL_STORE_DATA";
const reducers = (state, action) => {
  if (action.type === RESET_ALL_STORE_DATA) {
    return appReducers(undefined, action)
  }

  return appReducers(state, action)
}

export default reducers
